// eslint-disable-next-line import/prefer-default-export
export function canUseDOM() {
  return typeof window !== 'undefined';
}
